<h1 mat-dialog-title>Confirmación</h1>
<div mat-dialog-content>
  <p>{{ mensaje }}</p>
</div>
<div mat-dialog-actions class="d-flex justify-content-center">
  <button class="sinBorde" mat-raised-button color="warn" (click)="cerrarDialogo()">No</button>
  <button class="sinBorde" mat-raised-button color="primary" (click)="confirmado()">Si</button>
</div>
